export default class Availability {
  id = ''
  contactId = ''
  date = ''
  hourlyCost = 0
  hourlyPrice = 0
  dailyDuration = 0
}
